// styles.js

// --- LAYOUT & CONTAINERS ---
// Use responsive padding (e.g. smaller on phones, larger on desktops)
export const containerStyle = { padding: '16px', backgroundColor: '#ffffff', minHeight: '100vh', color: '#111111', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif', boxSizing: 'border-box', width: '100%', overflowX: 'hidden' };
export const headerStyle = { display: 'flex', alignItems: 'center', marginBottom: '25px', gap: '20px', flexWrap: 'wrap' };
export const cardStyle = { background: '#ffffff', padding: '20px', borderRadius: '12px', border: '1px solid #cbd5e0', width: '100%', overflowX: 'auto', boxSizing: 'border-box', marginBottom: '20px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)' };
export const tabBar = { display: 'flex', gap: '10px', marginBottom: '20px', borderBottom: '2px solid #e2e8f0', paddingBottom: '10px', flexWrap: 'wrap' };


// --- BUTTONS & INTERACTION ---
export const navBtn = { padding: '8px 15px', background: '#ffffff', color: '#111111', border: '1px solid #cbd5e0', borderRadius: '6px', cursor: 'pointer', fontWeight: '600' };
export const activeTabBtn = { padding: '10px 20px', background: '#0066cc', color: '#ffffff', border: 'none', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer' };
export const inactiveTabBtn = { padding: '10px 20px', background: '#e2e8f0', color: '#4a5568', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold' };
export const submitBulkBtn = { padding: '15px', background: '#2f855a', color: '#ffffff', border: 'none', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer', fontSize: '15px', marginTop: '10px' };
export const cancelBtn = { padding: '8px 15px', background: '#e53e3e', color: '#ffffff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold', fontSize: '13px', transition: '0.2s' };
export const actionBtn = { padding: '12px', background: '#0066cc', color: '#ffffff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold', fontSize: '14px', boxSizing: 'border-box' };
export const saveTemplateBtn = { padding: '10px 20px', background: '#0066cc', color: '#ffffff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold', fontSize: '13px' };
export const trackerBtn = { padding: '8px 12px', background: '#e2e8f0', color: '#111111', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', fontWeight: 'bold' };


 // --- CALENDAR GRID ---

export const gridWrapper = {
    display: 'grid',
    gridTemplateColumns: '70px repeat(7, minmax(100px, 1fr))',
    gridAutoRows: '52px',
    gridAutoFlow: 'row',
    gap: '1px',
    background: '#cbd5e0',
    width: '100%',
    minWidth: '780px',
    border: '1px solid #cbd5e0',
    boxSizing: 'border-box',
    position: 'relative',
    alignItems: 'stretch'
};

export const dayHeader = {
    gridRow: '1',
    textAlign: 'center',
    padding: '6px',
    background: '#f8f9fa',
    borderBottom: '1px solid #cbd5e0',
    color: '#0066cc',
    fontWeight: 'bold',
    boxSizing: 'border-box',
    minWidth: 0
};

export const timeLabelHeader = {
    gridColumn: '1',
    gridRow: '1',
    background: '#f8f9fa',
    borderBottom: '1px solid #cbd5e0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '13px',
    fontWeight: 'bold',
    color: '#111111',
    boxSizing: 'border-box'
};

export const timeLabelCell = {
    fontSize: '12px',
    color: '#4a5568',
    textAlign: 'center',
    padding: '0',
    background: '#ffffff',
    fontWeight: 'bold',
    borderRight: '1px solid #e2e8f0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    minWidth: 0,
    height: '52px'
};

export const calendarCellBase = {
    ...timeLabelCell,
    userSelect: 'none',
    border: '1px solid #cbd5e0'
};



// --- FORMS & INPUTS ---
export const inputStyle = { padding: '12px', background: '#ffffff', border: '1px solid #cbd5e0', color: '#111111', borderRadius: '6px', width: '100%', boxSizing: 'border-box', fontSize: '14px' };
export const labelStyle = { fontSize: '12px', color: '#2d3748', fontWeight: 'bold', textTransform: 'uppercase', marginBottom: '5px' };
export const logInput = { width: '100%', height: '60px', background: '#ffffff', color: '#111111', border: '1px solid #cbd5e0', padding: '10px', borderRadius: '8px', marginBottom: '10px', boxSizing: 'border-box' };
export const formStyle = { display: 'flex', flexDirection: 'column', gap: '20px', maxWidth: '500px', marginTop: '20px' };
export const formGroup = { display: 'flex', flexDirection: 'column', gap: '8px', textAlign: 'left' };
export const selectStyle = { padding: '8px 12px', background: '#ffffff', color: '#111111', border: '1px solid #cbd5e0', borderRadius: '6px', fontSize: '14px' };

// --- MODALS & OVERLAYS ---
export const modalOverlay = { position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0, 0, 0, 0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 99999 };
export const modalContent = { background: '#ffffff', padding: '20px', borderRadius: '15px', width: '90%', maxWidth: '350px', textAlign: 'center', border: '1px solid #cbd5e0', color: '#111111', boxShadow: '0 10px 25px rgba(0,0,0,0.1)', boxSizing: 'border-box' };
export const largeModal = { background: '#ffffff', width: '95%', maxWidth: '850px', maxHeight: '90vh', padding: '20px', borderRadius: '15px', border: '1px solid #cbd5e0', color: '#111111', boxShadow: '0 10px 25px rgba(0,0,0,0.1)', boxSizing: 'border-box', overflowY: 'auto' };export const lockOverlay = { position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: '#ffffff', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 99999 };
export const lockModal = { background: '#ffffff', padding: '40px', borderRadius: '15px', border: '1px solid #cbd5e0', maxWidth: '400px', width: '100%', textAlign: 'center', display: 'flex', flexDirection: 'column', gap: '20px', color: '#111111', boxShadow: '0 10px 25px rgba(0,0,0,0.1)' };
export const modalHeader = { display: 'flex', justifyContent: 'space-between', marginBottom: '15px', alignItems: 'center' };
export const closeBtn = { background: 'none', color: '#4a5568', border: 'none', fontSize: '22px', cursor: 'pointer', fontWeight: 'bold' };

// --- UTILS ---
export const logoStyle = { width: '50px', height: '50px', borderRadius: '50%', border: '2px solid #0066cc', objectFit: 'cover' };
export const flexCol = { display: 'flex', flexDirection: 'column', gap: '10px' };
export const miniBarContainer = { width: '100%', height: '7px', background: '#e2e8f0', borderRadius: '4px', overflow: 'hidden', marginTop: '3px' };
export const miniBarFill = { height: '100%', transition: 'width 0.5s ease-in-out', borderRadius: '4px', background: '#0066cc' };
export const bottomGrid = { display: 'grid', gridTemplateColumns: '1fr 1.5fr', gap: '20px', marginTop: '10px' };
export const studentRow = { display: 'flex', justifyContent: 'space-between', padding: '12px 0', borderBottom: '1px solid #e2e8f0', alignItems: 'center' };
